
import ContactList from 'component/ContactList';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

const SearchCustomerTable = ({items, text, onSelect}) =>
{
  if (!items) return '';
  if (!items.length) return (
    <p className="message yellow">沒有匹配資料</p>
  );

  return (
    <table className="data-table full-width">
      <colgroup>
        <col width="80px"  id="col-sr-cust-btn" />
        <col width="60px"  id="col-sr-cust-id" />
        <col width="300px" id="col-sr-cust-name" />
        <col width="100px" id="col-sr-cust-vehicles" />
        <col width="auto"  id="col-sr-cust-contacts" />
      </colgroup>
      <thead>
        <tr>
          <th className="col-sr-cust-btn"></th>
          <th className="col-sr-cust-id">編號</th>
          <th className="col-sr-cust-name">名稱</th>
          <th className="col-sr-cust-vehicles">車輛</th>
          <th className="col-sr-cust-contacts">聯絡方法</th>
        </tr>
      </thead>
      <tbody>
        { items.map(x =>
          <tr key={x.id}>
            <td className="col-sr-cust-btn">
              <button className="btn small blue" onClick={e=>onSelect(x)}>
                <FontAwesomeIcon icon={faCaretLeft} title="選取" />
                <span> {text}</span>
              </button>
            </td>
            <td className="col-sr-cust-id">{ x.id }</td>
            <td className="col-sr-cust-name">{ x.display_name }</td>
            <td className="col-sr-cust-vehicles">
              { x.vehicles.map(v => <div key={v.cd_license}>{ v.cd_license }</div>) }
            </td>
            <td className="col-sr-cust-contacts">
              <ContactList contacts={ x.contacts } />
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
}

export default SearchCustomerTable;
